module.exports = __webpack_public_path__ + "img/mobtotquestions.8b1e6d63.svg";